'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconInfoCircle, iconInfoCircleTag } from '@ni/nimble-components/dist/esm/icons/info-circle';
import { wrap } from '../../utilities/react-wrapper';

export type { IconInfoCircle };
export { iconInfoCircleTag };
export const NimbleIconInfoCircle = wrap(IconInfoCircle);